import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class IndexService extends BaseService {
    getPayouts() {
        return this.get(`${VUE_APP_API_URL}/api/payout-summary`).then(({ data }) => data)
    }
}
export default new IndexService()